var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6_576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.5103,
    y: 6,
    width: 36,
    height: 35.0204,
    rx: 17.5102,
    transform: "rotate(90 41.5103 6)",
    fill: "#F26619"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5103,
    y: 3,
    width: 42,
    height: 41.0204,
    rx: 20.5102,
    transform: "rotate(90 44.5103 3)",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6224 33L18.9056 33.6973L19.6224 34.4341L20.3392 33.6973L19.6224 33ZM19.6224 23.75L18.6224 23.75L19.6224 23.75ZM21.8112 22.75C22.3635 22.75 22.8112 22.3023 22.8112 21.75C22.8112 21.1977 22.3635 20.75 21.8112 20.75L21.8112 22.75ZM14.5281 29.1973L18.9056 33.6973L20.3392 32.3027L15.9617 27.8027L14.5281 29.1973ZM20.3392 33.6973L24.7168 29.1973L23.2832 27.8027L18.9056 32.3027L20.3392 33.6973ZM20.6224 33L20.6224 23.75L18.6224 23.75L18.6224 33L20.6224 33ZM21.6224 22.75L21.8112 22.75L21.8112 20.75L21.6224 20.75L21.6224 22.75ZM20.6224 23.75C20.6224 23.1977 21.0701 22.75 21.6224 22.75L21.6224 20.75C19.9656 20.75 18.6224 22.0931 18.6224 23.75L20.6224 23.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3773 15L27.6605 14.3027L28.3773 13.5659L29.0941 14.3027L28.3773 15ZM28.3773 24.25L29.3773 24.25L28.3773 24.25ZM26.1885 27.25C25.6362 27.25 25.1885 26.8023 25.1885 26.25C25.1885 25.6977 25.6362 25.25 26.1885 25.25L26.1885 27.25ZM23.283 18.8027L27.6605 14.3027L29.0941 15.6973L24.7165 20.1973L23.283 18.8027ZM29.0941 14.3027L33.4717 18.8027L32.0381 20.1973L27.6605 15.6973L29.0941 14.3027ZM29.3773 15L29.3773 24.25L27.3773 24.25L27.3773 15L29.3773 15ZM26.3773 27.25L26.1885 27.25L26.1885 25.25L26.3773 25.25L26.3773 27.25ZM29.3773 24.25C29.3773 25.9069 28.0342 27.25 26.3773 27.25L26.3773 25.25C26.9296 25.25 27.3773 24.8023 27.3773 24.25L29.3773 24.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6_576",
    x: -59.5103,
    y: -60,
    width: 167.021,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6_576"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6_576",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.817c5d3a721e72a5ca3895d5bbed8146.svg";
export { ForwardRef as ReactComponent };